module.exports = __webpack_public_path__ + "static/media/fuel-dark.5e04e55a.svg";